// extracted by mini-css-extract-plugin
export default {"container":"DialogNotAllowBooking_container__jBnNP"};